




import { Component } from "vue-property-decorator";
import Vue from "vue";

@Component({
  name: "Dashboard",
})
export default class Dashboard extends Vue {}
